import { render, staticRenderFns } from "./VehicleType.vue?vue&type=template&id=67861aec&scoped=true&"
import script from "./VehicleType.vue?vue&type=script&lang=js&"
export * from "./VehicleType.vue?vue&type=script&lang=js&"
import style0 from "./VehicleType.vue?vue&type=style&index=0&id=67861aec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67861aec",
  null
  
)

export default component.exports